



























import { Component, Vue } from 'vue-property-decorator';
import { bus } from '../main';

@Component
export default class Start extends Vue {
	entity = this.$store.getters.entity

	get firstName(): string {
		if (this.entity) {
			return this.entity.name.split(' ')[0]
		} else {
			return ''
		}
	}
	get position(): string {
		if (this.entity) {
			return this.entity.position
		} else {
			return ''
		}
	}
	
	start(): void {
		this.$router.push({ name: 'entityData' })
	}

	mounted() {
		bus.$emit('initComplete')
		bus.$emit('setBottomText', 'Ziraf')
	}
}
